import React from 'react';
import classNames from 'classnames';

const V5Switch = ({ 
  id, 
  checked, 
  onChange, 
  label, 
  disabled = false, 
  className = '', 
  name, 
  value 
}) => {
  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked, { target: { name, value, checked: !checked } });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div className={classNames('v5-switch-wrapper', className)}>
      {label && <span className="v5-switch-text">{label}</span>}
      
      <div 
        id={id}
        role="switch"
        aria-checked={checked}
        aria-label={label}
        tabIndex={disabled ? -1 : 0}
        className={classNames('v5-switch-control', {
          'v5-switch-checked': checked,
          'v5-switch-disabled': disabled
        })}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
      >
        <span className="v5-switch-slider">
          <span className="v5-switch-thumb"></span>
        </span>
      </div>
      
      <input 
        type="hidden" 
        name={name} 
        value={checked ? value || 'true' : 'false'} 
      />
    </div>
  );
};

export default V5Switch; 